export default __webpack_public_path__ + "static/media/IMG_20220528_143040_167.df7641a4.jpg";